import {Component, OnInit, Optional, TemplateRef, ViewChild} from '@angular/core';
import {TableHeaderService} from '../../../../resources/services/table-header.service';
import {FormService} from '../../../../resources/services/form.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Location} from '@angular/common';
import {PermissionService} from '../../../../resources/services/permission.service';
import {StoreAppService} from '../../../../resources/services/store-app.service';
import {CardService} from "../../../../resources/components/card/card.service";
import {LoaderService} from "../../../../resources/services/loader.service";
import {finalize} from "rxjs/operators";
import {Subscription} from "rxjs";

@Component({
  selector: 'store-view-snapshots',
  templateUrl: './store-view-snapshots.component.html',
  providers: [LoaderService]
})
export class StoreViewSnapshotsComponent implements OnInit {

  @ViewChild('actions') set actionsTmp$(value: TemplateRef<any>) {
    if (!this.cardService) return;

    this.actionsTmp = value;

    if (value) {
      this.cardService.setPortal('actions', value);
    } else {
      this.cardService.clearPortal('actions');
    }
  }
  actionsTmp: TemplateRef<any>;

  json: any = {};
  id: any = this._route.parent.snapshot.params.id;

  snapshots: any[] = [];

  updateHook$: Subscription;

  constructor(public loaderService: LoaderService,
              private tableHeaderService: TableHeaderService,
              private _formService: FormService,
              private _route: ActivatedRoute,
              private _toastr: ToastrService,
              private _location: Location,
              private permissionService: PermissionService,
              private _router: Router,
              private _modelService: StoreAppService,
              @Optional() private cardService: CardService) {
    if (this.cardService) {
      this.cardService.refresher.show();
      this.updateHook$ = this.cardService.refresher.updateChanges.subscribe(() => {
        this.get();
      });
    }
  }

  ngOnInit(): void {
    this.get();
  }

  ngOnDestroy() {
    if (this.cardService) {

      if (this.actionsTmp) {
        this.cardService.clearPortal('actions');
      }

      this.cardService.refresher.hide();
    }

    if (this.updateHook$) {
      this.updateHook$.unsubscribe();
    }
  }

  get(): void {
    this.loaderService.show();

    let query = {
      id: this.id
    };

    this._modelService.getSnapshots(query)
      .pipe(
        finalize(() => {
          this.loaderService.hide();
        })
      )
      .subscribe((res: any) => {
          this.snapshots = res.map(item => Object.assign(item, {json: JSON.parse(item.json || '{}')}))
        },
        err => {
        }
      );
  }

  createSnapshot() {
    this.loaderService.show();
    this._modelService.createSnapshot({id: this.id})
      .pipe(
        finalize(() => {
          this.get();
          this.loaderService.hide();
        })
      )
      .subscribe((json) => {
        this.json = json;
      });
  }

  back(e?: any) {
    if (e) e.preventDefault();

    this._location.back();
  }

}
